function DownloadResumeJSON() {
  const getResumeData = {
    name: "Your Name",
    position: "Your Position",
    description:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam neque ligula, laoreet condimentum lacus nec, fermentum condimentum sapien. Vivamus eget libero pulvinar, scelerisque mauris sed, bibendum ipsum",
    email: "example@domain.com",
    ph_no: "1234567890",
    location: "City, Country",
    linkedin: "linkedin.com/in/username",
    lsLayout: [
      {
        title: "Education",
        type: "ed",
        record: [
          {
            degree: "Degree",
            university: "University",
            date: "MM/DD/YYYY",
          },
        ],
      },
      {
        title: "Work Experience",
        type: "exp",
        record: [
          {
            role: "Position",
            company: "Company",
            location: "City, Country",
            date: "MM/DD/YYYY",
            responsibilities: [
              "Responsibility 1",
              "Responsibility 2",
              "Responsibility 3",
            ],
          },
        ],
      },
      {
        title: "Languages",
        type: "lang",
        record: [
          {
            lang: "Language",
            rate: 2,
          },
        ],
      },
    ],
    rsLayout: [
      {
        title: "Skills",
        type: "skill",
        record: { skills: ["Skill 1", "Skill 2", "Skill 3"] },
      },
      {
        title: "Certificates",
        type: "cert",
        record: {
          certifications: [
            "Certificate 1",
            "Certificate 2",
            "Certificate 3",
            "Certificate 4",
          ],
        },
      },
    ],
  };

  return (
    <div
      className={`flex items-center gap-3 text-sm font-semibold rounded-lg bg-[#2a3035] text-dark-fg cursor-pointer mb-2 p-4 text-center`}
      title="Download Resume JSON"
      onClick={() => {
        const getJSON =
          "data:text/json;charset=utf-8," +
          encodeURIComponent(JSON.stringify(getResumeData));
        const anchorNode = document.createElement("a");
        anchorNode.setAttribute("href", getJSON);
        anchorNode.setAttribute("download", `${new Date().getTime()}.json`);
        anchorNode.click();
        anchorNode.remove();
      }}
    >
      <i className="fa fa-file-lines" />
      <div className="text-left">Download Template JSON</div>
    </div>
  );
}

export default DownloadResumeJSON;
